import { useState } from 'react';
import { useChartEvents } from '../../../charts/common/events/hooks/useChartEvents';
/**
 * Custom hook to manage the opacity of legend marks based on tooltip and legend hover events.
 */
export function useEventLegendMark(_ref) {
  let {
    tooltip,
    legend,
    labelAccessor
  } = _ref;
  // Hook to manage active tooltip state and compute opacity based on hover events.
  const [active, setActive] = useState();
  if (tooltip) {
    // Listen to tooltip events to update active state for legend mark.
    useChartEvents(tooltip, ['pointerout', 'pointermove'], d => {
      var _d$eventData, _d$eventData2;
      setActive({
        label: ((_d$eventData = d.eventData) === null || _d$eventData === void 0 ? void 0 : _d$eventData.distance) === 0 ? labelAccessor((_d$eventData2 = d.eventData) === null || _d$eventData2 === void 0 ? void 0 : _d$eventData2.datum) : undefined
      });
    });
  }

  // Listen to legend events to update active state for hovered legend item.
  useChartEvents(legend, d => {
    setActive({
      label: d.eventData
    });
  });

  // Determine opacity for a given arc based on the active tooltip state.
  const getActiveMark = () => {
    return active === null || active === void 0 ? void 0 : active.label;
  };
  return {
    getActiveMark
  };
}